export default __webpack_public_path__ + "static/media/sucity.96561906.jpg";